import gql from 'graphql-tag';

const USER_ROLE_PERMISSIONS_QUERY = gql`
  query userRolePermissions($id: ID, $action: String, $resource: String) {
    userRolePermissions(id: $id, action: $action, resource: $resource) {
      id
      action
      resource
      description
    }
  }
`;

const USER_PROLES_QUERY = gql`
  query userRoles($id: ID, $name: String) {
    userRoles(id: $id, name: $name) {
      id
      name
      permissions {
        id
        action
        resource
        description
      }
    }
  }
`;

const WORKERS_QUERY = gql`
  query users($ids: [ID], $mobile: String, $name: String, $isWorker: Boolean) {
    users(ids: $ids, mobile: $mobile, name: $name, isWorker: $isWorker) {
      id
      name
      mobile
      roles {
        id
        name
      }
    }
  }
`;

const PERMISSION_POSSESSIONS = ['any', 'own'];
const PERMISSION_ACTIONS = ['create', 'read', 'update', 'delete'];
export { USER_ROLE_PERMISSIONS_QUERY, USER_PROLES_QUERY, WORKERS_QUERY, PERMISSION_POSSESSIONS, PERMISSION_ACTIONS };



// WEBPACK FOOTER //
// ./src/screens/rolePermission/constant.ts